module.exports = __webpack_public_path__ + "static/media/wssp-sale.a1c33b01.png";